import { Component, OnInit, Input } from '@angular/core';
import { SplashAnimationType } from './splash-animation-type';
import { NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  imports: [NgIf, NgStyle],
  standalone: true,
})
export class SplashScreenComponent implements OnInit {
  @Input() animationDuration = 0.5;
  @Input() duration = 3;
  @Input() animationType: SplashAnimationType = SplashAnimationType.FadeOut;
  windowWidth!: string;
  splashTransition!: string;
  opacityChange = 1;
  showSplash = true;

  ngOnInit(): void {
    setTimeout(() => {
      let transitionStyle = '';
      if (this.animationType === SplashAnimationType.FadeOut) {
        transitionStyle = 'opacity ' + this.animationDuration + 's';
        this.opacityChange = 0;
      }

      this.splashTransition = transitionStyle;

      setTimeout(() => {
        this.showSplash = !this.showSplash;
      }, this.animationDuration * 1000);
    }, this.duration * 1000);
  }
}
